import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyPrice", "annualPrice", "intervalInput"]
  static values = { interval: { type: String, default: "monthly" } }

  declare intervalValue: string
  declare monthlyPriceTargets: HTMLElement[]
  declare annualPriceTargets: HTMLElement[]
  declare intervalInputTargets: HTMLInputElement[]

  intervalValueChanged(): void {
    const isAnnual = this.intervalValue === "annual"

    this.monthlyPriceTargets.forEach((el) => el.classList.toggle("d-none", isAnnual))
    this.annualPriceTargets.forEach((el) => el.classList.toggle("d-none", !isAnnual))
    this.intervalInputTargets.forEach((input) => {
      input.value = this.intervalValue
    })
  }

  toggle(event: Event): void {
    const target = event.currentTarget as HTMLInputElement
    this.intervalValue = target.checked ? "annual" : "monthly"
  }
}
